import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function BatteryConditionMeasuredAtDatePicker() {
  return (
    <Field
      type="apiDate"
      name="batteryConditionMeasuredAt"
      label={i18n.t('entity.vehicle.labels.batteryConditionMeasuredAt')}
    />
  );
}
